<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const list = computed(() => [
  {
    date: '2025.01',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-recdot.png',
    title: t('About.list.2501product'),
    info: t('About.list.2501info')
  },
  null,
  {
    date: '2023.05',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-nano.png',
    title: t('About.list.2305product'),
    info: t('About.list.2305info')
  },
  null,
  {
    date: '2022.12',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-air.png',
    title: t('About.list.2212product'),
    info: t('About.list.2212info')
  },
  null,
  {
    date: '2022.05',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/Rpro.png',
    title: t('About.list.2205product'),
    info: t('About.list.2205info')
  },
  null,
  {
    date: '2021.06',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-lite.png',
    title: t('About.list.2106product'),
    info: t('About.list.2106info')
  }
])

const selected = ref(list.value[0])

const choose = (item: any) => {
  if (item) selected.value = item
}
</script>

<template>
  <div class="card">
    <span class="title">{{ $t('About.milestones') }}</span>
    <ul class="lineStone">
      <li v-for="item in list" :key="item?.title" @click="choose(item)" :class="{ choosed: selected?.img == item?.img }">
        {{ item?.date }}
      </li>
    </ul>
    <div class="cartBox">
      <div class="cartimg">
        <img v-show="selected?.img === item2?.img" v-for="item2 in list" :key="item2?.title" :src="item2?.img" alt="" />
      </div>
      <div class="cartBox-bottom">
        <div class="content">
          <div class="titles">{{ selected?.title }}</div>
          <div class="text">{{ selected?.info }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    color: #202020;
    font-family: PingFang SC;
    font-size: 4.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 7.6rem;
  }

  .lineStone {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 3.2rem;
    margin-bottom: 4rem;
    gap: 0.8rem;
    cursor: pointer;

    li:nth-child(2n + 1) {
      display: flex;
      padding: 1.2rem 2.4rem;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      border-radius: 100rem;
      border: 0.1rem solid #d1d1d1;
      font-size: 1.8rem;
    }

    li:nth-child(2n) {
      flex:1;
      height: 0.1rem;
      background: #d1d1d1;
    }

    .choosed {
      color: #fff;
      background: #202020;
    }
  }

  .cartBox {
    position: relative;
    width: 100%;
    max-width: 83.8rem;
    aspect-ratio: 838/588;
    border-radius: 1.6rem;
    background: #fff;
    overflow: hidden;

    .cartimg {
      width: 100%;
      aspect-ratio: 838/408;
      max-height: 40.8rem;
      background-color: #f4f0eb;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .cartBox-bottom {
      width: 100%;
      aspect-ratio: 838/180;
      padding: 0 6.6rem;
      display: flex;
      align-items: center;

      .content {
        font-style: normal;
        line-height: normal;

        .titles {
          color: #000;
          font-size: 2.4rem;
          font-weight: 600;
        }

        .text {
          margin-top: 0.8rem;
          width: 100%;
          color: #bebebe;
          font-size: 1.6rem;
          font-weight: 400;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
